package fr.manyverse.app.presentation.components.player_screen.character.choice

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.cancel
import org.jetbrains.compose.resources.stringResource

/**
 * Attente pendant le chargement d'une liste de choix (personnages existants, pré-tirés).
 *
 * Les boîtes de dialogue de sélection ne sont composées qu'une fois leur liste définitive :
 * `SelectPreMadeDialog` fige l'état de son carrousel sur la taille initiale de la liste, une
 * liste qui grandit après coup le casserait.
 *
 * @param title titre affiché : libellé de chargement, ou libellé d'erreur si [error] est fourni.
 */
@Composable
fun ChoiceLoadingDialog(
    title: String,
    onDismiss: () -> Unit,
    error: String? = null
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(title) },
        text = {
            Box(
                modifier = Modifier.fillMaxWidth().padding(vertical = 16.dp),
                contentAlignment = Alignment.Center
            ) {
                if (error != null) {
                    Text(
                        text = error,
                        color = MaterialTheme.colorScheme.error,
                        style = MaterialTheme.typography.bodyMedium
                    )
                } else {
                    CircularProgressIndicator()
                }
            }
        },
        confirmButton = {
            TextButton(onClick = onDismiss) {
                Text(stringResource(Res.string.cancel))
            }
        }
    )
}
